/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import {
  LIBRARY_ITEM_TYPES,
  loaderSvg,
  mapContentType,
  mapLayoutType,
  mapLibraryItemToKey,
  mappedContentTypes,
} from '@pwc/pwc-deals-report-ui/build/components/ReportPreview/utils';
import { SectionItem } from '@pwc/pwc-deals-report-ui/build/components/ReportPreview/types';
import {
  generateHTML,
  generateRichtextHTML,
  generateRichtextHTMLStructured,
} from '@pwc/pwc-deals-report-ui/build/components/ReportPreview/DomHelper';
import {
  fixInsight,
  fixPartData,
} from '../../../../common/helpers/reportPreviewUtils';
import { Constants } from '@pwc/pwc-deals-web-common';
import { cloneDeep } from 'lodash';
import { useMemo } from 'react';
import { parseLibraryItemsForAdjustment } from 'features/contentLibrary/libraryItemService';
import { POWER_PIVOT_LIBRARY_ITEM_TYPES } from 'features/analyses/common/LibraryItemCard/PowerPivot/constants/PowerPivotTypes';

export const generateAdjustmentDescriptionHTML = (
  element: Element,
  libraryItems: { [key: string]: string }
) => {
  const ckElement = element.querySelector('.ck-editor__editable');
  if (ckElement) {
    const paragraphs = ckElement?.querySelectorAll(
      '.rich-text-editor-paragraph'
    );
    paragraphs.forEach((paragraph) => {
      const div = document.createElement('div');
      div.innerHTML = paragraph.outerHTML;
      const placeholders = div.querySelectorAll('.placeholder.ck-widget');

      placeholders.forEach((placeholder) => {
        const { id } = placeholder;
        // @ts-ignore
        const storeItem = window.__LIBRARYITEMSTORE__.get(id);
        placeholder.innerHTML = storeItem?.renderedSvg;
      });
      const autosync = div.querySelector('.content-item-link');
      if (autosync) {
        div.innerHTML = div.innerHTML.replace(autosync.innerHTML, '');
      }
      paragraph.outerHTML = div.outerHTML;
    });
  }

  return ckElement?.innerHTML || '';
};

const mapItem = (item: SectionItem, contentType: string) => {
  return {
    area:
      contentType === mappedContentTypes.FREEFORM
        ? item.analysisColumn
        : item.column,
    order: item.order,
    key: mapLibraryItemToKey(item.id),
  };
};

const structuredAnalysisLayout = (territory: string, contentType: string) => {
  if (territory === Constants.TERRITORY_CODES.UNITED_KINGDOM) {
    return {
      type: 'table-full',
      name: `Table Full ${contentType}`,
      layout: 'DetailedTableLayout',
    };
  } else if (territory === Constants.TERRITORY_CODES.UNITED_STATES) {
    return {
      type: 'table-summary',
      name: `Table Summary ${contentType}`,
      layout: 'RepeatedSummaryTableLayout',
    };
  }

  return {
    type: 'table-summary',
    name: `Table Summary ${contentType}`,
    layout: 'SummaryTableLayout',
  };
};

export const getConvertedAnalysis = ({
  title,
  pageId,
  analysis,
  insightId,
  descriptionId,
  sections,
  libraryItems,
  territory,
}) => {
  const div = document.querySelector(pageId);
  let html = div?.querySelectorAll('.rich-text-library-item-edit');
  const contentType = mapContentType(analysis.type, analysis.subtype);

  const insightElement = document.querySelector(insightId);

  const allTextElement = insightElement?.querySelectorAll(
    '.rich-text-editor-paragraph'
  );
  const allTextElementArr = [];
  allTextElement.forEach((part) => {
    allTextElementArr.push(part.innerHTML);
  });

  const insight = fixInsight(allTextElementArr.join(' ')) ?? '';

  const descriptionElement = document.querySelector(descriptionId);
  const descriptionCKInnerHTML =
    descriptionElement?.querySelector('.ck.ck-content')?.innerHTML;
  const description = `<p>${fixInsight(descriptionCKInnerHTML) ?? ''}</p>`;

  const parts = (sections || []).flatMap((section) => {
    const orderItems = [...section.items].sort((a, b) => {
      if (a.analysisColumn < b.analysisColumn) {
        return -1;
      }
      if (a.analysisColumn > b.analysisColumn) {
        return 1;
      }
      return 0;
    });
    return orderItems.map((item: SectionItem) => {
      if (!LIBRARY_ITEM_TYPES[`${item.type}`]) {
        console.error(`Unknown library item type ${item.type}`);
      }

      const isPowerpiviot = Object.values(
        POWER_PIVOT_LIBRARY_ITEM_TYPES
      ).includes(item.type);

      const type = isPowerpiviot
        ? 'placeholder-image'
        : LIBRARY_ITEM_TYPES[`${item.type}`];

      return {
        type,
        key: mapLibraryItemToKey(item.id),
        name: item.name,
        data: '',
        id: item.id,
      };
    });
  });

  const convertedAnalysis = {
    type: 'freeformanalysis',
    content: {
      id: analysis.contentThreadId,
      contentType: '', // TODO: what?
      sections: sections?.map((section) => {
        const newSection = {
          order: section.order,
          layout: mapLayoutType(section.layoutType),
          positions: section.items.map((item) => {
            const newItem = mapItem(item, contentType);
            return newItem;
          }),
        };
        return newSection;
      }),
      parts: [
        {
          type: 'description',
          key: '',
          name: '',
          data: `<p>${description}</p>`,
        },
      ],
      connections: { insights: [] }, // TODO: what?
      title,
      status: analysis.versionStatus === 3 ? 'shared' : 'draft',
      modifiedBy: analysis.modifiedBy, // TODO: fixme
      modifiedDate: analysis.dateModified, // TODO: fixme
      source: '', // TODO: what?
      notes: '', // TODO: what?
      layout: '', // TODO: what?
      tags: [], // TODO: what?
    },
    insight,
    projectDetail: {
      name: '', // TODO: fixme
      territory,
      stamped: '', // TODO: what?
    },
  };
  parts.forEach((part, index) => {
    // React mounts and unmounts, invalidating nodes
    if (!html) {
      html = document
        .querySelector(pageId)
        .querySelectorAll('.rich-text-library-item-edit');
    }

    const element = (html || [])[index];

    if (!part.data) {
      part.data =
        part.type !== 'rich-text'
          ? generateHTML(part.id, libraryItems)
          : generateRichtextHTML(element, libraryItems).replace(/\u2060/g, '');
    }
    if (part.data) {
      const div = document.createElement('div');
      div.innerHTML = part.data;
      const queryItems = div.querySelectorAll('.content-item-link');

      if (queryItems && queryItems.length > 0) {
        queryItems.forEach((item) => {
          div.innerHTML = div.innerHTML.replace(item.innerHTML, '');
        });
      }
      part.data = fixPartData(div.innerHTML);
    }

    if (
      (!part.data || part.data === loaderSvg) &&
      (part.type === 'power-bi-report-page' || part.type === 'power-bi-report')
    ) {
      part = {
        type: 'static-image',
        key: part.id ? `library-item-${part.id}` : part.key,
        name: part.name,
        data: loaderSvg,
        id: part.id,
      };
    }

    if (
      part.type === 'power-bi-report-page' ||
      part.type === 'power-bi-report'
    ) {
      part = {
        ...part,
        type: 'placeholder-image',
      };
    }

    convertedAnalysis.content.parts.push(part);

    /**
     * If !part.data evaluates to true,
     * then No rendered data for part
     */
  });

  return convertedAnalysis;
};

export const getConvertedStructuredAnalysis = ({
  title,
  pageId,
  analysis,
  insightId,
  descriptionId,
  libraryItems,
  territory,
  connections,
  tableSummary,
  notes,
  source,
  chart,
  structuredAnalysesSection,
  allParts,
  basisOfPresentation,
  projectId,
  isPwcUser,
}) => {
  const div = document.querySelector(pageId);
  const html = div?.querySelectorAll('.rich-text-library-item-edit');
  const contentType = mapContentType(analysis.type, analysis.contentSubType);

  const { layout, type, name } = structuredAnalysisLayout(
    territory,
    contentType
  );
  const table = tableSummary?.outerHTML;
  const chartSVG = `<?xml version="1.0"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN""http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">${chart?.outerHTML}`;

  const insightElement = document.querySelector(insightId);
  const allTextElement = insightElement?.querySelectorAll(
    '.rich-text-editor-paragraph'
  );
  const allTextElementArr = [];
  allTextElement.forEach((part) => {
    allTextElementArr.push(part.innerHTML);
  });

  const insight = fixInsight(allTextElementArr.join(' ')) ?? '';

  const parsedBasisOfPresentation = parseLibraryItemsForAdjustment({
    projectId,
    value: basisOfPresentation?.data,
    isPwcUser,
  });
  const allPartsArr = cloneDeep(allParts);
  allPartsArr.forEach((part) => {
    // replace the placeholders
    const div = document.createElement('div');
    div.innerHTML = part.data;

    const placeholders = div.querySelectorAll('.placeholder.ck-widget');

    placeholders.forEach((placeholder) => {
      const { id } = placeholder;
      // eslint-disable-next-line no-underscore-dangle
      const storeItem = window.__LIBRARYITEMSTORE__.get(id);
      placeholder.innerHTML = storeItem?.renderedSvg || storeItem?.rendered;
    });

    part.data = fixPartData(div.innerHTML);
  });

  const parts = [
    {
      type: 'basis-of-presentation',
      key: null,
      name: 'Basis of Presentation',
      data: parsedBasisOfPresentation,
    },
    {
      type,
      key: null,
      name,
      data: table,
    },
  ].concat(allPartsArr);

  parts.forEach((part) => {
    const div = document.createElement('div');
    div.innerHTML = part.data;

    const queryItems = div.querySelectorAll('.content-item-link');

    if (queryItems && queryItems.length > 0) {
      queryItems.forEach((item) => {
        div.innerHTML = div.innerHTML.replace(item.innerHTML, '');
      });
    }
    part.data = fixPartData(div.innerHTML);
  });

  const convertedAnalysis = {
    type: 'structuredanalysis',
    content: {
      id: analysis.contentThreadId,
      contentType: contentType,
      sections: structuredAnalysesSection,
      parts,
      connections,
      title,
      status: analysis.versionStatus === 3 ? 'shared' : 'draft',
      modifiedBy: analysis.modifiedBy, // TODO: fixme
      modifiedDate: analysis.dateModified, // TODO: fixme
      source: source,
      notes: notes,
      layout,
      tags: [], // TODO: what?
    },
    insight,
    projectDetail: {
      name: '', // TODO: fixme
      territory,
      stamped: '', // TODO: what?
    },
  };

  return convertedAnalysis;
};
